import { profileStepSchema } from "./profile-step.schema";
import type { ProfileStepInputs } from "./profile-step.schema";

// ============================================================================
// Full Form Schema (Final Submission)
// - Student onboarding has a single step; the full schema mirrors the step schema
// ============================================================================

export const fullSchema = profileStepSchema;

// ============================================================================
// Full Form Type
// ============================================================================

export type StudentOnboardingFormInputs = ProfileStepInputs;
